import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import { TextLoader } from '~/components'


export default class extends React.Component {
    static propTypes = {
		bookmarks: PropTypes.array.isRequired,
		fetching: PropTypes.bool
	};

    state = {
        amountToShow: 10
    };

    showMore = () => {
		this.setState({
			amountToShow: this.state.amountToShow + 10
		})
	};

    render() {
		
		return (

			<div>
				{ this.props.fetching
					? <TextLoader />
					: this.props.bookmarks.length > 0
						? <div>
			            	{ this.props.bookmarks.slice(0, this.state.amountToShow).map( bookmark => {
								return <div className="side-tab bookmark-tab" key={'bookmark-' + bookmark.uniqueID}>
									<div className="p10">
										<p><Link to={bookmark.link}>{ bookmark.title }</Link></p>
										<p className="small text-dark-gray">{bookmark.post_type.singular_upper}</p>
									</div>
									<hr className="m0" />
								</div>
							}) }
							{ this.state.amountToShow < this.props.bookmarks.length &&
								<div className="side-tab bookmark-tab">
									<div className="p10 clickable" onClick={this.showMore}>
										<p><i className="icon-plus"></i> View more</p>
									</div>
								</div>
							}
						</div>
						: <div className="side-tab bookmark-tab">
							<p className="p10 text-center small">No bookmarks</p>
						</div>
				}
			</div>

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/SideBarRight/Sidebar-Bookmarks.jsx